import React, {useEffect, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import "./index.css"

import { Sidebar } from 'primereact/sidebar';

// Inputs
import { Table, Button } from '../../helpers';
import Search from './Components/Search';
import { InputSwitch } from 'primereact/inputswitch';
import moment from "moment"
import { Tooltip } from 'primereact/tooltip';

// Common
import CopyToClipboard from '../../common/CopyToClipboard';

// utils
import { getProductName, getProductSpecification, isMobile } from '../../utils';


// redux
import { fetchStockSnapshot, updateSearchParams } from '../../services/redux/reducers/stock/stockSnapshot';
import { fetchStockMoveTypes, fetchCompanyWarehouses, fetchMaterialBrands, fetchStatus } from '../../services/redux/reducers/commonThunk';
import { raiseToast } from '../../services/redux/reducers/toast/toast';


const StockSnapshot = () => {

    const dispatch = useDispatch()
    const navigate = useNavigate()

    const [isFilterShown, setIsFilterShown] = useState(false)

    const isPageLoading = useSelector(state => state.stockSnapshot.loading)
    const stockSnapshotData = useSelector(state => state.stockSnapshot.stockSnapshotData)
    const paginationParams = useSelector(state => state.stockSnapshot.paginationParams)
    const searchParams = useSelector(state => state.stockSnapshot.searchParams)
    const searchOptions = useSelector(state => state.stockSnapshot.searchOptions)
    const stockMoveTypes = useSelector(state => state.common.stockMoveTypes)
    const companyWarehouses = useSelector(state => state.common.companyWarehouses)
    const materialBrands = useSelector((state) => state.common.materialBrands)
    const statusList = useSelector((state) => state.common.status)

    const isMobileDevice = isMobile()

    console.log("stockSnapshotData", stockSnapshotData)

    useEffect(()=>{
        dispatch(fetchStockMoveTypes())
        dispatch(fetchCompanyWarehouses())
        dispatch(fetchMaterialBrands())
        dispatch(fetchStatus())
        getIntialLoadData()
    },[])

    const getIntialLoadData = () => {
        if(isPageLoading){
            let toDate = new Date()
            toDate.setHours(23, 59, 0, 0)
            toDate = toDate.toISOString()

            let fromDate = new Date()
            fromDate.setDate(fromDate.getDate() - 30)
            fromDate.setHours(0, 0, 0, 0)
            fromDate = fromDate.toISOString()

            const updatedSearchParams = {
                ...searchParams,
                fromDate: fromDate,
                toDate: toDate
            }

            dispatch(updateSearchParams(updatedSearchParams))
        }
    }

    useEffect(() => {
        handleTableColumn(searchParams)
    }, [stockSnapshotData])


    const handleOnClickFilter = event => {
        setIsFilterShown(current => !current);
    }

    const handlePageChange = async (e) => {
        let getCompanyParams = { 
            paginator: true, 
            pageNo: e.page + 1, 
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            ...searchParams
        }
        dispatch(fetchStockSnapshot(getCompanyParams))
    }

    const handleTableColumn = (searchParams) => {
        const { dataType } = searchParams

        switch(dataType) {
            case "stockDoc" :
                setTableColumns(tableStockDocColumns)
                break
            case "stockWarehouse" :
                setTableColumns(tableStockWarehouseColumns)
                break
        }
    }

    const getWareHouseNameBody = (row) => {
        const relatedCompanyWarehouse = companyWarehouses.find((each) => each.warehouseId === row?.warehouseId)
        if(relatedCompanyWarehouse?.warehouseName){
            return relatedCompanyWarehouse.warehouseName
        }else{
            return '-'
        }
    }

    const getDocNoBody = (row) => {
        if(row?.docNo){
            return(
                <div className="text-center">
                    <div className='flex flex-row justify-content-center'>
                        <p className='doc-no' style={{ cursor: "pointer" }}>{row?.docNo}</p>
                        <CopyToClipboard text={row?.docNo} />
                    </div>
                </div>
            )
        }else{
            <div> - </div>
        }
    }

    const getProductBody = (row) => {
        let relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === row?.materialMaster?.brandId)
        let productName = getProductName(relatedBrand?.brandName,row?.materialMaster?.productName, row?.materialMaster?.variantName)
        return (
            <div>{productName}</div>
        )
    }

    const getProductSpecificationBody = (row) => {
        let productSpecification = getProductSpecification(row?.materialMaster?.productSpecification, row?.materialMaster?.UOM,row?.materialMaster?.UOMValue)
        return (
            <div>{productSpecification}</div>
        )
    }

    const getStatusBody = (row) => {
        let relatedStatus = statusList.find(eachStatus => eachStatus.statusId === row.statusId)

        return (
            <div>{relatedStatus?.status}</div>
        )
    }

    const tableStockDocColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Product',
            field: '',
            body: getProductBody,
            style: { minWidth: "200px"}
        },
        {
            header: 'Specifications',
            field: '',
            body: getProductSpecificationBody,
            style: { minWidth: "300px"}
        },
        {
            header: 'Doc No',
            field: '',
            body: getDocNoBody,
            style: { minWidth:"130px"}
        },
        {
            header: 'Doc Qty',
            field: 'docQty',
            style: { minWidth:"110px"}
        },
        {
            header: 'Pending Qty',
            field: 'pendingQty',
            style: { minWidth:"110px"}
        },
        {
            header: 'InProcess Qty',
            field: 'inProcessQty',
            style: { minWidth:"130px"}
        },
        {
            header: 'Invoiced Qty',
            field: 'invoicedQty',
            style: { minWidth:"130px"}
        },
        {
            header: 'Adjusted Qty',
            field: 'adjustedQty',
            style: { minWidth:"130px"}
        },
        {
            header: 'CNDN Qty',
            field: 'CNDNQty',
            style: { minWidth:"110px"}
        }
    ]


    const tableStockWarehouseColumns = [
        {
            header: 'Material Id',
            field: 'materialId',
        },
        {
            header: 'Product',
            field: '',
            body: getProductBody,
            style: { minWidth: "130px"}
        },
        {
            header: 'Specifications',
            field: '',
            body: getProductSpecificationBody,
            style: { minWidth: "200px"}
        },
        {
            header: 'Warehouse Name',
            field: '',
            body: getWareHouseNameBody,
        },
        {
            header: 'In Stock',
            field: 'inStock',
        },
        {
            header: 'Out Stock',
            field: 'outStock',
        },
        {
            header: 'Dispatched Stock',
            field: 'dispatchedStock',
            style: { minWidth: "130px"}
        },
        {
            header: 'Smart Stock',
            field: 'smartStock',
        },
        {
            header: 'Rejected Stock',
            field: 'rejectedStock',
            style: { minWidth: "130px"}
        },
        {
            header: 'Discarded Stock',
            field: 'discardedStock',
            style: { minWidth: "130px"}
        },
        {
            header: 'Last Smart Price',
            field: 'lastSmartPrice',
            style: { minWidth: "130px"}
        },
        {
            header: 'Last Rejected Price',
            field: 'lastRejectedPrice',
            style: { minWidth: "130px"}
        },
        {
            header: 'Smart Stock Price',
            field: 'smartStockPrice',
            style: { minWidth: "130px"}
        },
        {
            header: 'Status',
            field: '',
            body: getStatusBody
        },
    ]

    let [ tableColumns, setTableColumns ] = useState(tableStockDocColumns)


    return(
        <div className='flex flex-column'>
            <div className="flex flex-column md:flex-row md:justify-content-between">
                <h4 className="mx-2 my-1 md:m-2">STOCK SNAPSHOT</h4> 
                <div className="flex gap-2 justify-content-end mb-2">
                    <Button icon="pi pi-filter" className="h-2rem  p-2 action-btn hover:surface-400 hover:text-700 surface-300" label="Filter" onClick={handleOnClickFilter} />
                </div>
            </div>

            <div className='flex flex-row'>
                <div className="stock-snapshot-table" style={{ order: "1", width: isFilterShown && !isMobileDevice ? "82%" : "100%", maxHeight: "'calc(100%-100px)'" }}>
                    <div className='p-card mb-0' >
                        <div className="flex-grow-1" >
                            <Table 
                                lazy 
                                page={paginationParams.pageNo} 
                                onPageChange={(e)=> handlePageChange(e)} 
                                totalRecords={paginationParams.totalRecords} 
                                tableColumns={tableColumns} 
                                data={stockSnapshotData} 
                                rows={paginationParams.recordsPerPage} 
                                scrollable={"true"} 
                                scrollHeight="550px"
                                paginator
                                excessPagesFound= {paginationParams.excessPagesFound}
                                loading={isPageLoading}  
                            />
                        </div>
                    </div>
                </div>

                {
                    isFilterShown && !isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px"}}  className="justify-content-end">
                        <Search handleTableColumn={handleTableColumn} companyWarehouses={companyWarehouses} statusList={statusList} />
                    </div>
                }
                {
                    isFilterShown && isMobileDevice &&
                    <div style={{ order: "2", width: "18%", paddingLeft: "10px"}}  className="justify-content-end">
                        <Sidebar position='right' visible={isFilterShown} onHide={() => setIsFilterShown(false)}>
                            <Search handleTableColumn={handleTableColumn} companyWarehouses={companyWarehouses} statusList={statusList} />
                        </Sidebar>
                    </div>
                }

            </div>

        </div>
    )
}

export default StockSnapshot